import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import className from 'classnames';
import { toggleEventPreviewMode } from "../../../../../../store/actions/admin/create-event";
import ModalComponent from "../../../../../general-ui/modal/modal";
import RegistrationPage from '../../../../../live-event/registration/registration';
import './event-preview.scss';
import LiveEventDocumentHead from "../../../../../live-event/live-event-document-head";
import { useParams } from "react-router";
import { ParamsProps } from "../../../../../live-event/live-event";

interface RegistrationPreviewProps {
	open: boolean;
}

const RegistrationPreviewModal: React.FC<RegistrationPreviewProps> = ({ open }) => {
	const {
		workingEvent,
		editorSize
	} = useTypedSelector(state => ({
		workingEvent: state.CreateEventReducer.workingEvent,
		editorSize: state.CreateEventReducer.editorSize
	}));

	const [openPreview, setOpenPreview] = useState(false);

	const dispatch = useDispatch();

	const { language } = useParams() as ParamsProps;

	const modalBody = useMemo(() => {
		return workingEvent && (
			<div className={className('registration-preview-wrapper live-event-container', editorSize)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<RegistrationPage previewLanguage={language || "en"} />
			</div>
		);
	}, [workingEvent, editorSize, language]);

	useEffect(() => {
		setOpenPreview(open);
	}, [open]);

	const closeModal = useCallback(() => {
		setOpenPreview(false);
		// set timeout to prevent flashing
		setTimeout(() => dispatch(toggleEventPreviewMode(null)), 300);
	}, [dispatch]);

	return (
		<div className="preview-modal">
			<ModalComponent
				open={openPreview}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default RegistrationPreviewModal;